import React from 'react';
import { Star, ArrowRight } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    name: 'Carlos M.',
    location: 'Houston, TX',
    image: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?auto=format&fit=crop&q=80&w=150&h=150',
    text: 'Pensé que nunca podría comprar casa por mi mal crédito. Usé las cartas de disputa de este programa y en 4 meses borraron 3 colecciones.',
    scoreBefore: 580,
    scoreAfter: 740
  }, {
    name: 'Ana P.',
    location: 'Miami, FL',
    image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&q=80&w=150&h=150',
    text: 'El mejor dinero invertido. Las agencias me cobraban $100 al mes y no hacían nada. Aquí aprendí a hacerlo yo misma y los resultados son reales.',
    scoreBefore: 610,
    scoreAfter: 785
  }, {
    name: 'Roberto G.',
    location: 'Los Angeles, CA',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&q=80&w=150&h=150',
    text: 'Llegué a este país sin saber cómo funcionaba el crédito. Con solo ITIN logré construir mi historial desde cero siguiendo la guía paso a paso.',
    scoreBefore: 'N/A',
    scoreAfter: 720
  }];
  return <section className="py-24 bg-white" data-id="element-139">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-140">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-141">
          <h2 className="text-3xl md:text-4xl font-bold text-navy-900 mb-4" data-id="element-142">
            Resultados Reales de{' '}
            <span className="text-gold-500" data-id="element-143">Latinos Reales</span>
          </h2>
          <p className="text-lg text-slate-600" data-id="element-144">
            Únete a miles de personas que ya han transformado su vida
            financiera.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-145">
          {testimonials.map((t, idx) => <div key={idx} className="bg-slate-50 p-8 rounded-2xl border border-slate-200 shadow-sm h-full flex flex-col" data-id="element-146">
              <div className="flex text-gold-500 mb-4" data-id="element-147">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current" data-id="element-148" />)}
              </div>

              <p className="text-slate-700 italic mb-6 flex-grow" data-id="element-149">"{t.text}"</p>

              <div className="bg-white p-4 rounded-xl border border-slate-100 mb-6 flex items-center justify-between" data-id="element-150">
                <div className="text-center" data-id="element-151">
                  <p className="text-xs text-slate-500 uppercase font-bold mb-1" data-id="element-152">
                    Antes
                  </p>
                  <p className="text-lg font-bold text-red-500" data-id="element-153">
                    {t.scoreBefore}
                  </p>
                </div>
                <ArrowRight className="w-5 h-5 text-slate-300" data-id="element-154" />
                <div className="text-center" data-id="element-155">
                  <p className="text-xs text-slate-500 uppercase font-bold mb-1" data-id="element-156">
                    Después
                  </p>
                  <p className="text-lg font-bold text-green-500" data-id="element-157">
                    {t.scoreAfter}
                  </p>
                </div>
              </div>

              <div className="flex items-center gap-4" data-id="element-158">
                <img src={t.image} alt={t.name} className="w-12 h-12 rounded-full object-cover" data-id="element-159" />
                <div data-id="element-160">
                  <h4 className="font-bold text-navy-900" data-id="element-161">{t.name}</h4>
                  <p className="text-sm text-slate-500" data-id="element-162">{t.location}</p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}